import { Component, OnDestroy } from '@angular/core';
import { PosthogService } from '../services/posthog.service';
import { GetterService } from 'src/app/service/getter-service.service';
import { ApiService } from 'src/app/service/api.service';
import { Subscription } from 'rxjs';
import { ThemeService } from 'src/app/service/theme.service';

/**
 * Shown only for brands on `Analytics.ConsentMode = 'consent'`. The default
 * cookieless mode stores nothing on the device, so no banner is needed there —
 * the visitor's opt-out lives on the privacy page instead.
 */
@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnDestroy {
  consentGiven = this.local.get('analyticsConsent') === 'true';
  consent;
  /** analytics enabled AND the brand wants a consent banner */
  enabled: boolean;
  webCusSub: Subscription;
  /* brands without a Theme keep their DynamicStyle button colour (see ThemeService.legacyAccentVars) */
  accentVars: Record<string, string> | null = null;

  constructor(
    private posthogService: PosthogService,
    private local: GetterService,
    private apiService: ApiService,
    private theme: ThemeService
  ) {
    this.getWebCustomer();
  }

  ngOnDestroy(): void {
    this.webCusSub.unsubscribe();
  }

  getWebCustomer() {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }

      const analytics = res.TemplateData?.Analytics;
      this.enabled = !!analytics?.Enabled && analytics?.ConsentMode === 'consent';
      this.accentVars = this.theme.legacyAccentVars(res);
    });
  }

  acceptConsent() {
    this.posthogService.giveConsent();
    this.posthogService.captureEvent('consent_accepted', {
      consentType: 'analytics',
    });
    this.consentGiven = true;
    this.consent = true;
  }

  declineConsent() {
    // nothing is running yet, so there is nothing to send this to
    this.posthogService.revokeConsent();
    this.consentGiven = false;
    this.consent = false;
  }
}
